module.exports = __webpack_public_path__ + "img/w5-b4.0573b760.jpg";